module.exports = __webpack_public_path__ + "img/plus.b23880bb.svg";